module.exports = __webpack_public_path__ + "c3ddcf6c247bc7c97be8dac257d666d4.MP3";